// extracted by mini-css-extract-plugin
module.exports = {"curtain":"Modal_curtain__RYo2g","content":"Modal_content__B55AF","active":"Modal_active__hzrmC"};